export default "__VITE_ASSET__4da244ae__"